import { lazyRouteComponent } from "@tanstack/react-router";

import type { PageDef } from "@/app/registry";

export const pages: PageDef[] = [];

/**
 * The Pro agreement page (V087), opened from the offer email. Outside /app/ on
 * purpose: Android App Links hand /app/... links to the app, and an offer is
 * accepted (and paid) on the website only. It asks for a sign-in itself.
 */
export const publicPages: PageDef[] = [
  {
    path: "/pro-offer",
    title: "Pro Member offer",
    component: lazyRouteComponent(() => import("./ProOfferPage"), "ProOfferPage"),
    validateSearch: (s) => (typeof s.t === "string" ? { t: s.t } : {}),
  },
];
